export const serverUrl = "https://leetcode-question-tracker.herokuapp.com";
// export const serverUrl = "http://localhost:8000";
